export default function CRIFunctionController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  userService,
  serviceIds,
  loaderService,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.eCat;
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpandCRIFunction = _handleExpandCRIFunction;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    return userService.getUserPermissionSet('ecat').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('updateCounts', (event, opt) => {
      if (opt.criFunctionId === vm.criFunction.criFunctionId) {
        _updateFunctionCount(opt.add, opt.remove);
      }
    });
  }

  function _handleExpandCRIFunction() {
    vm.isCRIFunctionExpanded = !vm.isCRIFunctionExpanded;
  }

  function _updateFunctionCount(addTypeId, removeTypeId) {
    if (vm.isEdit) {
      if (addTypeId == 1) {
        vm.criFunction.notStartedCount = vm.criFunction.notStartedCount + 1;
      } else if (addTypeId == 2) {
        vm.criFunction.inProgressCount = vm.criFunction.inProgressCount + 1;
      } else if (addTypeId == 3) {
        vm.criFunction.completedCount = vm.criFunction.completedCount + 1;
      } else if (addTypeId == 4) {
        vm.criFunction.notIncludedCount = vm.criFunction.notIncludedCount + 1;
      }

      if (removeTypeId == 1) {
        vm.criFunction.notStartedCount = vm.criFunction.notStartedCount - 1;
      } else if (removeTypeId == 2) {
        vm.criFunction.inProgressCount = vm.criFunction.inProgressCount - 1;
      } else if (removeTypeId == 3) {
        vm.criFunction.completedCount = vm.criFunction.completedCount - 1;
      } else if (removeTypeId == 4) {
        vm.criFunction.notIncludedCount = vm.criFunction.notIncludedCount - 1;
      }
    }
  }
}

CRIFunctionController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'userService',
  'serviceIds',
  'loaderService',
];
